<!-- eslint-disable func-names -->

<template>
  <div class="tender-confirmation">
    <div class="tender-confirmation__content">
      <div class="documents-information">
        <div class="carrier stops-info-card">
          <span class="carrier__title">Carrier</span>

          <span class="carrier__name">
            <b-icon
              class="carrier__icon inline-icon"
              icon="truck"
              font-scale="1"
            />
            {{ selectedCarrier.carrier }}, {{ selectedCarrier.serviceClass }},
            <span class="documents-information__text">
              USD ${{ carrierPrice.toFixed(2) }}
            </span>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FormatEasyPostPrices from "@/Extend/FormatEasyPostPrices";
import formatterCarrierName from "../../../../Extend/FormatCarrierName";

export default {
  name: "TenderConfirmation",
  mixins: [formatterCarrierName, FormatEasyPostPrices],
  props: {
    chosenLoad: { type: Object, required: true },
    selectedCarrier: { type: Object, required: true },
    originalCarrierArray: { type: Array, default: () => [] },
    isDrayage: { type: Boolean, default: false },
  },
  data() {
    return {
      loading: false,
      creatingTender: false,
      files: [],
      portalNotes: "",
      isPickup: false,
      isInsurance: false,
    };
  },
  created() {
    this.isPickup = this.parseQueryBoolean(this.$route.query.pickup);
    this.isInsurance = this.parseQueryBoolean(this.$route.query.insurance);
  },
  computed: {
    carrierPrice() {
      const fee = Number(this.chosenLoad?.cargocare_insurance_selling_rate_amount);
      const insuranceFee = Number.isFinite(fee) ? fee : 0;
      if (this.isDrayage) {
        const carrierPrice = Number(this.selectedCarrier?.price);
        const base = Number.isFinite(carrierPrice) ? carrierPrice : 0;
        return base + (this.isInsurance ? insuranceFee : 0);
      }

      const rawBasePrice = this.isPickup
        ? this.formatEasyPostPriceWithPickup(this.selectedCarrier)
        : this.formatEasyPostPriceWithoutPickup(this.selectedCarrier);
      const basePrice = Number(rawBasePrice);
      const normalizedBasePrice = Number.isFinite(basePrice) ? basePrice : 0;

      return normalizedBasePrice + (this.isInsurance ? insuranceFee : 0);
    },
  },
  methods: {
    parseQueryBoolean(value) {
      if (value === true || value === false) return value;
      if (value === "true") return true;
      if (value === "false") return false;
      return Boolean(value);
    },
  },
};
</script>

<style lang="scss" scoped>
///****Import styles****\\\\
@use '@/assets/scss/_variables' as *;
.carrier{
  display: flex;
  flex-direction: column ;
  align-items: flex-start;
  justify-content: flex-start;
  margin: 0px 0px 30px auto;
  width: 95%;

  &__title {
    color: $color-primary-company;;
    font-weight: 700;
    padding-bottom: 20px;
    font-size: 22px;
    font-weight: 600;
  }
  &__name {
    display: flex;
    align-items: flex-start;
    font-size: 16px;
    font-weight: 500;
    text-align: start;
    gap: 8px;
  }
  &__icon {
    color: $color-border-container;
    margin-top: 4px
  }
}
</style>
